export const themes = {
  light: {
    layoutBackground: "#FFFFFF",
    textInputBackground: "#D9D9D9",
    buttonBackground: "#C00000",
    appTextColor: "#000000",
    appLinksColor: "#FF0000",
    textInputPlaceholderColor: "#999999",
    bottomTabBackground: "#FFFFFF",
    bottomTabIconColor: "#000000",
    bottomTabHighlighted: "#C00000",
    notificationCount: "#C00000",
  },
  dark: {
    layoutBackground: "#000000",
    textInputBackground: "#D9D9D9",
    buttonBackground: "#C00000",
    appTextColor: "#FFFFFF",
    appLinksColor: "#FF0000",
    textInputPlaceholderColor: "#999999",
    bottomTabBackground: "#141414",
    bottomTabIconColor: "#FFFFFF",
    bottomTabHighlighted: "#C00000",
    notificationCount: "#C00000",
  },
};
